<template>
    <BreadCrumb PageTitle="Rechargement par Paypal" />
    <RechargePayPal/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import RechargePayPal from "@/components/Compte/RechargePayPal.vue";
  
    export default defineComponent({
      name: "RechargePayPalPage",
      components: {
        BreadCrumb,
        RechargePayPal,
      },
    });
  </script>